import React, { useMemo } from 'react';
import { ReportTransactionDataRow } from '@hone-automation/common';
import { useGetReportAttachments } from 'hooks';
import { Loader } from 'rsuite';
import { IconAttachment } from 'components/Icons';
import { prefixClass } from 'lib/utils';
import { useTransactionsTableContext } from '../../../Chart/context/TransactionsTableContext';
import { Transaction } from '../../TransactionsTable';
import { AttachmentMetadata } from 'hooks/useAttachmentsModal';

type TransactionsTableAttachmentsCellProps = {
  width?: string;
  transaction: Transaction;
  attachmentsLoading?: boolean;
  attachmentsData?: ReportTransactionDataRow[] | undefined;
};

export default function TransactionsTableAttachmentsCell({
  width,
  transaction,
  attachmentsLoading,
  attachmentsData,
}: TransactionsTableAttachmentsCellProps) {
  const prefix = prefixClass('transactions-table-cell-data');
  const { showAttachment } = useTransactionsTableContext();

  const attachments: string[] = useMemo(() => {
    if (!attachmentsData || !transaction) return [];
    return (
      attachmentsData.find((row: ReportTransactionDataRow) => {
        return row.eventId === transaction.eventId;
      })?.attachments || []
    );
  }, [attachmentsData, transaction]);

  const handleClick = (attachments: string[]) => {
    const attachmentMetadata: AttachmentMetadata = {
      amount: transaction.amount,
      description: transaction.name,
      title: transaction.name,
      date: transaction.date,
    };
    showAttachment(attachments, attachmentMetadata);
  };

  return (
    <>
      <td width={width} className={prefix('attachments')}>
        {attachmentsLoading ? (
          <Loader />
        ) : attachments?.length ? (
          <div className={prefix('attachments-pill')} onClick={() => handleClick(attachments)}>
            <IconAttachment />
            <span>{attachments.length}</span>
          </div>
        ) : null}
      </td>
    </>
  );
}
